import { find, get, isEmpty } from 'lodash';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Contracts from '../../../../api/api-contracts';
import { PaymentDetailsMain } from '../../app-bookings-payment-details/payment-details-main';
import { normalizeContracts } from '../../app-bookings-request/forms/bookingUtil';
import { PageSpinner } from '../../shared-components/decorators/spinner';
import { initAuth } from '../actions/auth';
import { fetchBooking } from '../actions/booking';
import { fetchContractsSnapshot } from '../actions/contracts';
import { fetchEnvWeb } from '../actions/env';
import { fetchPayment } from '../actions/payment';

export class PaymentDetailsContainer extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cancellationObj: {},
      fetchingCancelledContracts: false,
      displayError: ''
    };
  }

  componentDidMount() {
    const { dispatch, accessToken, profile, routeParams, env, booking } =
      this.props;
    if (!accessToken) {
      window.location.href = '/';
      return;
    }

    if (isEmpty(profile.data)) {
      dispatch(initAuth(accessToken));
    }

    const bookingId = routeParams?.bookingID;
    const ssoId = PSSessions.Cookies('PSUser');
    if (isEmpty(booking?.booking)) {
      dispatch(fetchBooking(bookingId, accessToken));
    }

    dispatch(fetchContractsSnapshot(bookingId, accessToken));
    dispatch(fetchPayment(bookingId, accessToken, ssoId));
    if (isEmpty(env?.web)) {
      dispatch(fetchEnvWeb());
    }
  }

  componentWillReceiveProps(nextProps) {
    const { booking, accessToken, token } = nextProps;
    const { cancellationObj, fetchingCancelledContracts } = this.state;
    if (
      !isEmpty(booking.booking) &&
      get(booking, 'booking.obj_state', '') === 'CANCELLED' &&
      isEmpty(cancellationObj) &&
      !fetchingCancelledContracts
    ) {
      this.setState({ fetchingCancelledContracts: true }, () => {
        return Contracts.readContractCancellation(
          get(booking, 'booking._id', ''),
          accessToken || token,
          (response) => {
            if (200 === response.statusCode) {
              this.setState({
                cancellationObj: response,
                fetchingCancelledContracts: false
              });
            } else {
              this.setState({
                displayError: this.props.intl.formatMessage({
                  id: 'inbox.current_details_container.something_wrong',
                  defaultMessage: 'Something went wrong, please try again.'
                }),
                fetchingCancelledContracts: false
              });
            }
          }
        );
      });
    }
  }

  render() {
    const { contract, payment } = this.props;
    const { fetchingCancelledContracts, cancellationObj } = this.state;

    const pendingContract = get(contract, 'data.pending', {});
    const pendingMasterContract =
      find(pendingContract, { type: 'MASTER' }) || {};
    const isRequestedState =
      pendingMasterContract.state === 'PENDING_GUEST_REQUEST_ACCEPT';

    const cancelledContracts = get(cancellationObj, 'previous', []);
    let displayContracts;
    if (cancelledContracts.length) {
      displayContracts = cancelledContracts;
    } else {
      displayContracts = isRequestedState
        ? pendingContract
        : get(contract, 'data.contracts');
    }
    const normalizedContracts = normalizeContracts(displayContracts);
    return !normalizedContracts?.masterContract ||
      fetchingCancelledContracts ||
      !payment?.hasFetched ? (
      <PageSpinner additionalStyle='gray' />
    ) : (
      <PaymentDetailsMain
        {...this.props}
        normalizedContracts={normalizedContracts}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { auth, profile, contract, payment, env, booking } = state;
  const { accessToken } = auth;

  return {
    accessToken,
    profile,
    contract,
    payment,
    env,
    booking
  };
};

export default injectIntl(
  connect(mapStateToProps)(PaymentDetailsContainer)
);
